import { defineStore } from "pinia";

export const useleadrBoardDetails = defineStore("leaderboardstore", {
  state: () => ({
    leaderboard: {},
  }),
  getters: {
    getLeaderBoardDetails: (state) => {
      return state.leaderboard;
    },
  },
  actions: {
    async getLeaderBoardData() {
      try {
        let data = await this.$request.get(this.apiEndpoints.LEADER_BOARD);
        if (data.data) {
          this.leaderboard = data.data.item;
        }
      } catch (error) {}
    },
    async sendFriendRequest(customerId) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.LEADER_BOARD_SEND_FRIEND_REQUEST(customerId)
        );
        if (data.data) {
          return data.data;
        }
      } catch (error) {}
    },
  },
});
